<script setup>
import {
  useHead,
  useScrollTopOnMounted,
  useRoute,
  useSanityQuery,
  computed,
} from '#imports';
import { getCommonMetaTags } from '~/utils/get-common-meta-tags';
import NewsletterCard from '~/components/newsletter-card.vue';
import GridComponent from '~/components/grid-component/grid-component.vue';
import { getQuery as getNewsletterPage } from '~/groq-queries/newsletter-page';
import { useImageSource } from '~/composables/use-image-source';
import PageCover from '~/components/news-page/page-cover/page-cover.vue';

useScrollTopOnMounted();

const route = useRoute();

const title = 'Антивоенная рассылка — DOXA';
const description =
  'Каждый день узнавайте новости, читайте о способах сопротивления и продолжайте борьбу против российского империализма и государства!';

const contentQuery = getNewsletterPage();
const { data: pageContent } = await useSanityQuery(contentQuery);

const ogImageUrl = computed(() =>
  useImageSource({ image: pageContent.value.image })
);

useHead({
  title,
  meta: getCommonMetaTags({
    path: route.fullPath,
    ogType: 'website',
    title,
    description,
    ogImageUrl: ogImageUrl.value,
  }),
});
</script>

<template>
  <LayoutStaticPage>
    <div class="antiwarletter-page">
      <div class="antiwarletter-page__cover">
        <PageCover
          :image-src="pageContent.image"
          :title-image="pageContent.titleImage"
          with-counter
        />
      </div>
      <div class="antiwarletter-page__container">
        <ArticleContent :content="pageContent" is-static-page></ArticleContent>
        <SubscriptionForm is-new-layout />
        <GridComponent
          v-if="pageContent.newsletterCards.length > 0"
          :elements="pageContent.newsletterCards"
          title="Предыдущие рассылки"
        >
          <template #element="{ element }">
            <NewsletterCard :item="element" />
          </template>
        </GridComponent>
      </div>
    </div>
  </LayoutStaticPage>
</template>

<style lang="postcss" scoped>
.antiwarletter-page {
  position: relative;
  z-index: 2;

  &__container {
    max-width: var(--content-narrow-max-width);
    margin: 24px auto 80px auto;
    padding: 0;

    @media (--medium-vp) {
      padding: 0 30px;
    }

    @media (--small-vp) {
      padding: 0 12px;
    }
  }

  &__form {
    margin-bottom: 80px;
  }
}
</style>
